<!-- begin Proyectos e Iniciativas -->
<div class="module">
  <div class="container-fluid">
    <div class="module__header">
      <div class="module__title">
        <h3
          class="mat-typography__headline mat-typography__headline--white mb-sm-0"
        >
          Novedades
        </h3>
      </div>
      <a
        routerLinkActive="active"
        routerLink="/novedades"
        class="link-underlined link-underlined--white"
        >Ver todas las novedades</a
      >
    </div>
    <!-- ToDo: INés_20231128: usar campo -->
    <div class="module__items">
      <ng-container *ngIf="elementos$.length > 0; else noNews">
        <ng-container *ngFor="let elemento of elementos$; let i = index">
          <a href="/novedades/{{ elemento.id }}">
            <div class="mat-card--project" *ngIf="i < 3">
              <div class="imgContainer">
                <img src="{{ img_base }}{{ elemento.detailImage }}" />
              </div>
              <div class="information">
                <h4>{{ elemento.nombre }}</h4>
                <p class="description">{{ elemento.copete }}</p>
              </div>
            </div>
          </a>
        </ng-container>
      </ng-container>
      <ng-template #noNews>
        <div class="no-items-message" style="color: #333; padding: 40px; text-align: center; width: 100%; font-size: 1.1rem;">
          <p>No hay novedades para mostrar en este momento.</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<!-- end Proyectos e Iniciativas -->
